import React from 'react';
import { motion } from 'framer-motion';

const ServiceCard = ({ title, icon: Icon, points }) => {
    return (
        <motion.div
            className="bg-white p-8 rounded-3xl border border-gray-100 hover:border-secondary/30 transition-all duration-500 group h-full flex flex-col shadow-sm hover:shadow-xl"
            whileHover={{ y: -8 }}
        >
            <div className="flex items-center mb-8">
                <div className="w-14 h-14 bg-logo-gradient rounded-2xl flex items-center justify-center shadow-sm transform group-hover:rotate-[10deg] transition-transform duration-500">
                    <Icon className="w-7 h-7 text-white transition-all" />
                </div>
            </div>

            <h3 className="text-2xl font-bold text-primary mb-4 transition-all duration-300">
                {title}
            </h3>

            <ul className="space-y-3 flex-grow">
                {points.map((point, index) => (
                    <li key={index} className="flex items-start text-primary/80 text-sm font-medium leading-relaxed">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary/30 mt-1.5 mr-3 flex-shrink-0"></span>
                        {point}
                    </li>
                ))}
            </ul>
        </motion.div>
    );
};

export default ServiceCard;
